import { app, analytics, logEvent } from './firebaseConfig';

const createDefaultProperties = (user) => {
    if (!user) {
        return {};
    }
    return {
        'Name': user.displayName || '',
        'Email': user.email || '',
        'UserId': user.uid || '',
        'EmailVerified': user.emailVerified || '',
        'PhoneNumber': user.phoneNumber || '',
        'PhotoURL': user.photoURL || '',
        'Source': process.env.REACT_APP_APP_NAME || 'KaiOSApp'
    };
};

// Function to get client IP address
const getClientIP = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        return 'unknown';
    }
};

// Enhanced event logging with IP and additional data
const _logEvent = async (eventName, eventParameters) => {
    try {
        // Check if analytics is available
        if (!analytics) {
            return;
        }

        const clientIP = await getClientIP();
        const enhancedParameters = {
            ...eventParameters,
            'client_ip': clientIP,
            'user_agent': navigator.userAgent || 'unknown',
            'platform': navigator.platform || 'unknown',
            'screen_width': window.screen.width || 'unknown',
            'screen_height': window.screen.height || 'unknown',
            'timestamp': new Date().toISOString(),
            'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown'
        };
        
        logEvent(analytics, eventName, enhancedParameters);
    } catch (error) {
    }
};

const logEventWebsiteOpened = (user) => {
    const defaultProperties = createDefaultProperties(user);
    _logEvent('website_opened', defaultProperties);
};

const logEventLoggedIn = (user) => {
    if (!user) {
        return;
    }
    const defaultProperties = createDefaultProperties(user);
    _logEvent('logged_in', defaultProperties);
};

// Pages viewed event tracking
const logEventPagesViewed = async (user, url, source = 'unknown', pageTitle = '') => {
    if (!url) {
        return;
    }
    
    // Extract clean base URL without specific IDs
    let pageUrl = 'unknown';
    try {
        const urlObj = new URL(url);
        const path = urlObj.pathname + urlObj.hash;
        
        // Map URLs to clean base URLs without IDs
        if (path.includes('/podcast')) {
            pageUrl = '/podcast';
        } else if (path.includes('/settings')) {
            pageUrl = '/settings';
        } else if (path.includes('/settings')) {
            pageUrl = '/settings';
        } else if (path.includes('/episodePage/')) {
            pageUrl = '/episodePage';
        } else if (path.includes('/podcastdetail/')) {
            pageUrl = '/podcastdetail';
        } else if (path.includes('/updateprofile')) {
            pageUrl = '/updateprofile';
        } else if (path.includes('/terms')) {
            pageUrl = '/terms';
        } else if (path.includes('/privacy')) {
            pageUrl = '/privacy';
        } else if (path.includes('/addPodcast')) {
            pageUrl = '/addpodcast';
        } else {
            // Clean up the path to remove hash fragments
            pageUrl = path.replace('#', '');
        }
    } catch (error) {
        console.error('Error parsing URL:', error);
        pageUrl = 'unknown';
    }
    
    const defaultProperties = createDefaultProperties(user);
    const eventParameters = {
        ...defaultProperties,
        'page_url': pageUrl,
        'page_title': pageTitle,
        'navigation_source': source,
        'domain': new URL(url).hostname || 'unknown'
    };
    await _logEvent('pages_viewed', eventParameters);
};

const logEventEpisodeListened = (user, episodeData) => {
    if (!user) {
        return;
    }
    const defaultProperties = createDefaultProperties(user);
    const eventParameters = { 
        ...defaultProperties, 
        ...episodeData 
    };
    _logEvent('episode_listened', eventParameters);
};

const logEventEpisodeLiked = (user, episodeData) => {
    if (!user) {
        return;
    }
    const defaultProperties = createDefaultProperties(user);
    const eventParameters = { 
        ...defaultProperties, 
        ...episodeData 
    };
    _logEvent('episode_liked', eventParameters);
};

const logEventPodcastFollowed = (user, podcastData) => {
    if (!user) {
        return;
    }
    const defaultProperties = createDefaultProperties(user);
    const eventParameters = { 
        ...defaultProperties, 
        ...podcastData 
    };
    _logEvent('podcast_followed', eventParameters);
};

export {
    logEventWebsiteOpened,
    logEventLoggedIn,
    logEventPagesViewed,
    logEventEpisodeListened,
    logEventEpisodeLiked,
    logEventPodcastFollowed
};
